/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../app';

const root = createRoot(document.getElementById('root')!);
root.render(React.createElement(App));
